import { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { useAuth } from "../../hooks/useAuth";
import { tr } from "../../i18n";

interface SetupStatus {
  available: boolean;
  reason: string | null;
}

export function SetupPage() {
  const { setupFirstAdmin } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState<SetupStatus | null>(null);
  const [email, setEmail] = useState("admin.fantasquad@gmail.com");
  const [nome, setNome] = useState("Andrea Cerutti");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api
      .get<SetupStatus>("/setup/status")
      .then((res) => setStatus(res.data))
      .catch(() => setStatus({ available: false, reason: "network_error" }));
  }, []);

  if (status === null) {
    return (
      <div className="min-h-screen bg-bg text-fg flex items-center justify-center">
        <p className="text-fg-muted">{tr("Verifica disponibilità setup…")}</p>
      </div>
    );
  }

  if (!status.available) {
    return <Navigate to="/login" replace />;
  }

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError(tr("La password deve avere almeno 8 caratteri"));
      return;
    }
    setLoading(true);
    try {
      await setupFirstAdmin(email, password, nome);
      // setupFirstAdmin naviga a / automaticamente
    } catch (err) {
      setError(
        (err as { response?: { data?: { detail?: string } } }).response?.data?.detail ??
          tr("Errore durante la creazione dell'account"),
      );
    } finally {
      setLoading(false);
    }
    void navigate;
  };

  return (
    <div className="min-h-screen bg-bg text-fg flex items-center justify-center p-6">
      <div className="bg-bg-card border border-primary/30 rounded-card shadow-hero p-8 max-w-md w-full">
        <img
          src="/icon-white-192.png"
          alt="FantaSquad"
          className="w-20 h-20 mx-auto mb-4"
          onError={(e) => {
            e.currentTarget.src = "/icon-192.png";
          }}
        />
        <h1 className="font-display text-4xl text-accent text-center mb-2 tracking-wider">
          {tr("Benvenuto")}
        </h1>
        <p className="text-fg-muted text-center text-sm mb-6">
          {tr(
            tr(
              "Setup iniziale di FantaSquad. Stai creando l'account del primo Presidente Lega (fondatore).",
            ),
          )}
        </p>

        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Nome completo")}
            </label>
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Email")}
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-fg-muted mb-1">
              {tr("Password (min 8 caratteri)")}
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              className="w-full px-3 py-2 bg-primary-deep border border-primary-soft rounded-lg text-fg focus:outline-none focus:ring-2 focus:ring-accent"
            />
          </div>

          {error && (
            <div className="text-danger text-sm bg-danger/10 border border-danger/30 rounded p-3">
              ⚠️ {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-primary w-full">
            {loading ? tr("Creazione…") : tr("Crea il mio account")}
          </button>

          <p className="text-xs text-fg-muted text-center mt-4">
            {tr(
              tr(
                "Questa pagina è disponibile solo al primo deploy. Dopo la creazione, verrà auto-disabilitata.",
              ),
            )}
          </p>
        </form>
      </div>
    </div>
  );
}
